import type { IndustryPack } from '../types'

export const SAAS_V1: IndustryPack = {
  pack_id: 'saas_v1',
  industry: 'saas',
  pack_name: 'SaaS Churn, Retention & Onboarding',
  version: 1,
  rules: [
    {
      rule_id: 'SAAS_001_dark_pattern_cancel',
      severity: 'warn',
      match: { type: 'keyword_list', keywords: ['confirm you want to leave', 'are you sure you want to cancel', 'you will lose all your data', 'lose access immediately'] },
      message: 'Potential dark-pattern in cancellation flow. FTC guidelines discourage fear-based cancellation language.',
      cited_authority: 'FTC "Click to Cancel" Rule (2024)',
      suggested_rewrite_template: 'Acknowledge the cancellation clearly. Offer a pause or downgrade option without threats.',
    },
    {
      rule_id: 'SAAS_002_upgrade_pressure',
      severity: 'warn',
      match: { type: 'keyword_list', keywords: ['upgrade now or lose', 'limited time to upgrade', 'expiring soon', 'last chance to keep'] },
      message: 'High-pressure upgrade framing. Research shows 34% churn increase when users feel cornered.',
    },
    {
      rule_id: 'SAAS_003_renewal_aggressive',
      severity: 'warn',
      match: { type: 'keyword_list', keywords: ['auto-renews in', 'will be charged', 'you must act by', 'renew or lose access'] },
      message: 'Aggressive renewal framing. Opt-out language performs 18% better in B2B SaaS renewal A/B tests.',
      suggested_rewrite_template: 'Use "Your subscription continues" and offer a clear 1-click downgrade option.',
    },
    {
      rule_id: 'SAAS_004_onboarding_activation',
      severity: 'info',
      match: { type: 'keyword_list', keywords: ['get started', 'complete your setup', 'first step', 'activate your account'] },
      message: 'Onboarding CTA present. Check that it links to the single highest-value activation action (not the general dashboard).',
    },
    {
      rule_id: 'SAAS_005_tos_density',
      severity: 'info',
      match: { type: 'keyword_list', keywords: ['terms of service', 'by using this service', 'you agree to', 'subject to our terms'] },
      message: 'TOS reference in user-facing copy. Legal density at this point in the flow increases drop-off by 22%.',
    },
    {
      rule_id: 'SAAS_006_vague_value_claim',
      severity: 'warn',
      match: { type: 'keyword_list', keywords: ['best in class', 'industry leading', 'most powerful', 'number one solution'] },
      message: 'Vague superlative claim. B2B buyers respond better to specific benchmarks and customer case evidence.',
    },
    {
      rule_id: 'SAAS_007_readability',
      severity: 'info',
      match: { type: 'readability', metric: 'flesch_kincaid', threshold: 11, operator: '>=' },
      message: 'Reading grade level above 11. SaaS email copy performs best at 8th–10th grade.',
      suggested_rewrite_template: 'Shorten sentences. Use contractions. Remove jargon.',
    },
    {
      rule_id: 'SAAS_008_feature_jargon',
      severity: 'info',
      match: { type: 'regex', pattern: 'API|webhook|SDK|CLI|REST|GraphQL|OAuth', flags: 'i' },
      message: 'Technical jargon in what may be a non-technical user communication. Confirm this is the right audience.',
    },
  ],
}
